import { createSelector } from 'reselect'

import { selectAccount } from 'broker/selectors/account'

const selectAgentStats = createSelector(selectAccount, account => ({
  active_agents_count: account.active_agents_count,
  inactive_agents_count: account.inactive_agents_count,
  overdue_agents_count: account.overdue_agents_count,
  total_webinar_experienced: account.total_webinar_experienced,
  total_webinar_emerging: account.total_webinar_emerging,
  total_webinar_completed: account.total_webinar_completed,
  total_mobile_enabled: account.total_mobile_enabled
}))

export const selectActiveAgentsCount = createSelector(selectAgentStats, stats => stats.active_agents_count)
export const selectInactiveAgentsCount = createSelector(selectAgentStats, stats => stats.inactive_agents_count)
export const selectOverdueAgentsCount = createSelector(selectAgentStats, stats => stats.overdue_agents_count)
export const selectTotalWebinarExperienced = createSelector(selectAgentStats, stats =>  stats.total_webinar_experienced)
export const selectTotalWebinarEmerging = createSelector(selectAgentStats, stats => stats.total_webinar_emerging)
export const selectWebinarCompletedPercent = createSelector(selectAgentStats, stats => stats.total_webinar_completed ? stats.total_webinar_completed / 100.0 : 0.0)
export const selectMobileEnabledPercent = createSelector(selectAgentStats, stats => stats.total_mobile_enabled ? stats.total_mobile_enabled / 100.0 : 0.0)
